function taxNumberValidation(value, isRequired) {
	isRequired = isRequired || false;

	if (!value && !isRequired) {
		return true;
	}
	return /^[0-9]{8}-\d-[0-9]{2}$/.test(value);
}

export default taxNumberValidation;
